import { render } from "./AudioElement.vue?vue&type=template&id=c85c7884&scoped=true"
import script from "./AudioElement.vue?vue&type=script&lang=js"
export * from "./AudioElement.vue?vue&type=script&lang=js"

import "./AudioElement.vue?vue&type=style&index=0&id=c85c7884&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c85c7884"]])

export default __exports__